// extracted by mini-css-extract-plugin
export default {"modal_content":"ModalWindowContent_modal_content__0dNq7"};